import React from 'react';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';

// Import Images
import offlineImg from "../../assets/images/auth-offline.gif";
import {Link} from "react-router-dom";
import {Utils} from "custom";


const TooManySessionPage = () => {
    document.title = "Errore limite sessioni | CLTV Cloud";
    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col xl={5}>
                                <Card className="overflow-hidden">
                                    <CardBody className="p-4">
                                        <div className="text-center">
                                            <h3 className="mt-4 fw-semibold">Hai superato il numero massimo di sessioni</h3>
                                            <p className="text-muted mb-4 fs-14">Il tuo piano non prevede la connessione su più dispositivi</p>
                                            <Link to="/" className="btn btn-danger btn-sm"><i className="mdi mdi-close me-1"></i>Annulla</Link>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

export default TooManySessionPage;
